module.exports = __webpack_public_path__ + "media/src/images/logo-app-icon-a16ab0f8d75e98c9922deffe37b1320a.png";